import React from "react";
import PropTypes from "prop-types";
import { TableCell, Tooltip, Box } from "@mui/material";

const TruncatedCell = ({ value, maxWidth, align, eId }) => {
  return (
    <TableCell align={align}>
      <Tooltip title={value || "-"}>
        <Box
          sx={{
            maxWidth,
            display: "flex",
            flexDirection: "column",
            alignItems:
              align === "center" ? "center" : align === "right" ? "flex-end" : "flex-start",
          }}
        >
          <Box
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
            }}
          >
            {value || "-"}
          </Box>
          {eId && (
            <Box
              sx={{
                fontSize: "0.65rem",
                color: "text.secondary",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "100%",
              }}
            >
              #{eId}
            </Box>
          )}
        </Box>
      </Tooltip>
    </TableCell>
  );
};

TruncatedCell.propTypes = {
  value: PropTypes.string,
  maxWidth: PropTypes.number,
  align: PropTypes.oneOf(["left", "right", "center", "inherit", "justify"]),
  eId: PropTypes.any,
};

TruncatedCell.defaultProps = {
  value: "-",
  maxWidth: 200,
  align: "left",
};

export default TruncatedCell;
